// MARK: NPM Modules
import React from "react";
import StyleguideData from "types/globals/styleguide/styleguideData";
// MARK: Functionality
import CSS from "./css";
// MARK: React Component
// Props
interface Props {
  styleguide: StyleguideData
}
// Component
const GlobalCSS = ({ styleguide }: Props) => {
  // @ts-ignore
  const GlobalStyles = CSS(styleguide);
  // MARK: Render
  return <GlobalStyles />;
};

export default GlobalCSS;
